var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoginGoogleActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.3599 16.364C31.3599 15.2295 31.2581 14.1386 31.069 13.0913H16V19.2804H24.6108C24.2399 21.2804 23.1127 22.9749 21.4181 24.1094V28.124H26.589C29.6144 25.3385 31.3599 21.2367 31.3599 16.364Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0012 31.9995C20.3212 31.9995 23.943 30.5668 26.5902 28.1232L21.4194 24.1087C19.9866 25.0687 18.1539 25.6359 16.0012 25.6359C11.834 25.6359 8.30671 22.8214 7.04854 19.0396H1.70312V23.185C4.33583 28.4141 9.74671 31.9995 16.0012 31.9995Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.04722 19.0399C6.72723 18.0799 6.54541 17.0544 6.54541 15.9999C6.54541 14.9453 6.72723 13.9199 7.04722 12.9599V8.81448H1.70181C0.618177 10.9745 0 13.4181 0 15.9999C0 18.5817 0.618177 21.0253 1.70181 23.1853L7.04722 19.0399Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0012 6.36359C18.3503 6.36359 20.4594 7.17086 22.1175 8.7563L26.7066 4.16724C23.9357 1.58544 20.3139 0 16.0012 0C9.7467 0 4.33583 3.58543 1.70312 8.81448L7.04854 12.9599C8.30671 9.17812 11.834 6.36359 16.0012 6.36359Z",
    fill: "#EA4335"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginGoogleActive);
export default __webpack_public_path__ + "static/media/login-google-active.b00c4588caef1aaa439fbf7d8989208a.svg";
export { ForwardRef as ReactComponent };